export default class mathScript{
    constructor(system){
        this.system = system;
    }
    //数学函数脚本

    //得到对数
    Logn(num1,num2) {
        // var res = Math.log(num1,mum2);
        // return Math.round(res);
        return (Math.log(num2) / Math.log(num1)).toFixed(2);
    }

    //范围性取模
    Mod(num,min,max) {
        if(min != max)
        {
            var nMin = parseInt(min);
            var nMax = parseInt(max);
            var rlt = (num - nMin) % (nMax - nMin) + nMin;
            if(rlt < nMin)
                rlt += nMax - nMin;
            if(rlt > nMax)
                rlt -= nMax - nMin;
        }
        return rlt;
    }

    //求反正弦值
    Arcsin(num) {
        return Math.asin(num)*180/Math.PI;
    }

    //求反正切值
    Arctan(num) {
        return Math.atan(num)*180/Math.PI;
    }

    //求反正切值
    Arctan2(num1,num2) {
        return Math.atan2(num1,num2)*180/Math.PI;
    }

    //求正弦值
    Sin(num) {       
        return Math.sin(num*Math.PI/180).toFixed(2);
    }

    //求正切值
    Tan(num) {       
        return Math.tan(num*Math.PI/180).toFixed(2);
    }

    //求正切值
    Cos(num) {       
        return Math.cos((num/180)*Math.PI).toFixed(2);
    }

    //求反余弦值
    ArccosEx(num) {
        return Math.acos(num);
        //return Math.acos(num)*180/Math.PI;
    }

    //取整
    Int(num){
        return parseInt(num);
    }
    //获取指定位的二进制值取值（返回 0 或 1）此函数未在系统函数中开放。
    //数据库变量按位取值时(root/test/tag1.PV.03)由转义翻译(this.indexByte(root/test/tag1.PV,3))
    indexByte(value,index) {
        var w = parseFloat(value);
        var temp = w.toString(2);
        var startIndex = temp.length - index - 1;
        var endIndex = temp.length - index;
        var result = temp.substring(startIndex,endIndex);
        var result = parseInt(result);
        if(isNaN(result)){
            result = 0;
        }
        return result
    }
}


// WEBPACK FOOTER //
// ./src/js/script/js/mathScript.js